export const MostrarMensaje = (dispatch, tipo, arrayMensajes) => {
    dispatch({
        type: "OPEN_SNACKBAR",
        openMensaje: {
            open: true,
            severity: tipo,
            mensaje: arrayMensajes
        }
    });
}